import { render, staticRenderFns } from "./goods_category_list.vue?vue&type=template&id=6561e5b7"
import script from "./goods_category_list.vue?vue&type=script&lang=js"
export * from "./goods_category_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports